module.exports = __webpack_public_path__ + "static/media/Proxima-Nova-Reg.4cfaf727.woff";